export default class Singleton {
    constructor() {
        //alert('load singleton');
    }
}